import { Button, DataSource, DesignerInterface, Panel } from "@mcleod/components";
import { ReflectiveDialogs } from "@mcleod/components/src/base/ReflectiveDialogs";
import { Navigation } from "@mcleod/core";
import { DesignerDataSource } from "../DesignerDataSource";
import { PanelOpenModel } from "../PanelOpenModel";
import { DesignerTab } from "./DesignerTab";

export class DesignerDataSourcePanel extends Panel {
  targetPanel: Panel;
  buttonAdd: Button;
  buttonModelView: Button;

  constructor(tab: DesignerTab, props?) {
    super({ minHeight: 80, fillRow: true, borderColor: "strokeSecondary", borderWidth: 1, marginTop: 16, ...props });
    this.targetPanel = new Panel({ fillRow: true });
    this.buttonAdd = new Button({ width: 140, height: 26, padding: 4, color: "primary", caption: "Add datasource", imageName: "add", rowBreak: false });
    this.buttonAdd.addClickListener(event => {
      tab.modified = true;
      let dsName: string;
      for (let nextNum = 1; dsName == null && nextNum < 1000; nextNum++)
        if (tab.dataSources["source" + nextNum] == null)
          dsName = "source" + nextNum;
      const dataSource = new DataSource({id: dsName}, null, tab._designer, tab);
      tab.dataSources[dataSource.id] = dataSource;
      const dsPanel = new DesignerDataSource(tab.designer, dataSource);
      this.targetPanel.add(dsPanel);
      tab.designer.selectComponent(dsPanel, false);
      this.showEndpointSelector(dataSource, tab._designer);
    });
    this.buttonModelView = new Button({ width: 140, height: 26, padding: 4, color: "primary", caption: "View model", imageName: "magnifyingGlass", enabled: false });
    this.buttonModelView.addClickListener((event) => {
      tab.modified = true;
      const datasource = tab.designer.selectedComponents[0] as DesignerDataSource;
      if (datasource.designerDataSource.url != null)
      Navigation.navigateTo("designer/model/ModelDesigner?open=" + datasource.designerDataSource.url, { newTab: true, windowDecorators: false });
    });
    this.add(this.targetPanel);
    this.add(this.buttonAdd);
    this.add(this.buttonModelView);
  }

  updateIds() {
    for (const dsPanel of this.targetPanel)
      (dsPanel as DesignerDataSource).updateId();
  }

  showEndpointSelector(dataSource: DataSource, designer: DesignerInterface) {
    const sel = new PanelOpenModel();
    ReflectiveDialogs.showDialog(sel, { height: 600, width: 500, title: "Select Endpoint" }).then(() => {
      const result = sel.getValue();
      if (result !== undefined) {
        dataSource.url = result;
        designer.redisplayProp("url", result);
        designer.displayDataSourceTools();
      }
    });
  }
}
